export const primaryColor = "#062952";
export const secondaryColor = "#3CB957";
export const secondaryColorDisabled = "#E2E8F0";
export const borderColor = "#E2E8F0";
export const activeColor = "#1A365D";
export const successColor = "#38A169";
export const errorColor = "#E53E3E";
